import * as React from 'react'

import { Box, Section, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Toggler from 'modules/core/components/Toggler'
import asyncAction from 'modules/core/lib/asyncAction'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

const CoffreFortNumerique = () => {
  const [coffreFortActive, setCoffreFortActive] = React.useState(hasFeature('coffre_fort'))

  const activateCoffreFort = async () => {
    const { success } = await asyncAction(() =>
      companies.current.rpc({
        rootUrl: '/coffre_fort_numerique/activate_coffre_fort_numerique',
      })
    )

    if (success) setCoffreFortActive(true)
  }

  const label = coffreFortActive
    ? i18n.t(
        'app_store_v2.apps.payroll_bundle.settings.coffre_fort_numerique.toggle_description_active'
      )
    : i18n.t('app_store_v2.apps.payroll_bundle.settings.coffre_fort_numerique.toggle_description')

  const content = (
    <Box gap="s12">
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal weight="medium" color="grey1000">
          {i18n.t('app_store_v2.apps.payroll_bundle.settings.coffre_fort_numerique.toggle_title')}
        </Text.Normal>
        <Toggler
          disabled={coffreFortActive}
          active={coffreFortActive}
          onChange={activateCoffreFort}
        />
      </Box>
      <Box paddingTop="s8">
        <Text.Normal size="300">{label}</Text.Normal>
      </Box>
    </Box>
  )

  return (
    <Box
      component="ul"
      borderRadius={{ all: 'abs016' }}
      background="grey000White"
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
      padding="s16"
    >
      {content}
    </Box>
  )
}

const CoffreFortNumeriqueComponent = () => {
  return (
    <Section
      title={i18n.t('app_store_v2.apps.payroll_bundle.settings.coffre_fort_numerique.title')}
      illustration="common-file-text-upload"
      description={i18n.t(
        'app_store_v2.apps.payroll_bundle.settings.coffre_fort_numerique.description'
      )}
    >
      <CoffreFortNumerique />
    </Section>
  )
}

export default observer(CoffreFortNumeriqueComponent)
